@use "styles" as *;

$block: me-footer;

.#{$block} {
  display: flex;
  flex-direction: column;

  @include hide-on-print;

  > * {
    padding: space(0, 4);
  }

  &__section {
    &--body {
      background-color: $color-gray-100;
    }

    &--medienhaus {
      background-color: $color-background;
    }
  }

  &__body, &__medienhaus {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: space(4, 0);

    @include remove-first-and-last-child-margins;
  }

  &__medienhaus {
    display: flex;
    flex-direction: column;

    &:not(&--active) {
      pointer-events: none;
      justify-content: center;
    }

    @include media-breakpoint-up(md) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }

  .me-button.#{$block}__button {
    &--logo {
      padding: 0;
    }

    &--link {
      @include media-breakpoint-up(md) {
        padding-right: 0;
      }
    }
  }

  &__logo {
    width: auto;
    height: auto;
    max-height: $me-footer-logo-height;

    &--dark-mode {
      display: none;
    }
  }
}

@mixin dark-mode {
  .#{$block}__logo {
    &--light-mode {
      display: none;
    }

    &--dark-mode {
      display: block;
    }
  }
}

body {
  &.dark-mode {
    @include dark-mode;
  }

  @media (prefers-color-scheme: dark) {
    &:not(.light-mode) {
      @include dark-mode;
    }
  }
}
